import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=a066361e&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=a066361e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a066361e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a066361e')) {
      api.createRecord('a066361e', component.options)
    } else {
      api.reload('a066361e', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=a066361e&scoped=true&", function () {
      api.rerender('a066361e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bopLGgPRloRQ/JS/comp/CookieBox.vue"
export default component.exports